import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import React, { forwardRef, useMemo } from 'react';
import { CardSection } from './CardSection.js';
import { themed } from '@indeed/ifl-css';
import transition from '../../utils/transition.js';
import { matchesDisplayName } from '../../utils/displayName.js';
import { jsx } from '@emotion/react';

const CARD_DEFAULT_TAG = "div";
const StyledCard = /*#__PURE__*/themed(CARD_DEFAULT_TAG, process.env.NODE_ENV === "production" ? {
  styleProps: ["selected"],
  shouldForwardProp: prop => prop !== "selected",
  target: "esu7hk30"
} : {
  styleProps: ["selected"],
  shouldForwardProp: prop => prop !== "selected",
  target: "esu7hk30",
  label: "StyledCard"
})(_ref => {
  let {
    selected
  } = _ref;
  return [{
    bg: "background",
    border: "1px solid",
    borderColor: "border.weak",
    borderRadius: "lg",
    display: "block",
    overflow: "hidden",
    whiteSpace: "normal"
  }, selected !== undefined && {
    cursor: "pointer",
    boxShadow: "none",
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.default, "border-color", "background-color", "box-shadow");
    },
    ":focus-visible": {
      outline: "none",
      boxShadow: "focus"
    },
    "&:hover": {
      boxShadow: "low"
    },
    "&:active": {
      boxShadow: "inset"
    }
  }, selected === true && {
    boxShadow: "medium",
    borderColor: "border.primary"
  }];
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

/**
 * @see https://experience.indeed.design/components/ids/card
 */
const Card = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    children,
    ...props
  } = _ref3;
  const tabIndex = props.selected !== undefined ? 0 : undefined;
  const wrapChildren = useMemo(() => {
    if (!children) return true;

    // Check if any direct child is a CardSection
    const childrenArray = React.Children.toArray(children);
    return !childrenArray.some(child => matchesDisplayName([CardSection], child));
  }, [children]);
  return jsx(StyledCard, _extends({
    ref: ref,
    tabIndex: tabIndex
  }, props), wrapChildren ? jsx(CardSection, null, children) : children);
});

export { CARD_DEFAULT_TAG, Card };
